import request from '@/utils/request'

// 获取路由
export function getRouters () {
    return request({
      url: '/system/menu/getRouters',
      method: 'get'
    })
}
export function getNewVersion () {
    return request({
      url: `${process.env.VUE_APP_API_WMS_URL}/paas-business/apkmanage/version/latest`,
      method: 'get'
    })
}
export function getShopWorkInfo (query) {
  return request({
    url: '/mes/mesDiscreteJobs/supplierNameByWorkshopCode',
    method: 'get',
    params: query
  })
}
